import * as $ from 'jquery';
import slugify from "slugify";
import TranslationsService from "../services/translationsService";

namespace PFF.controllers.supportArticle {
	const translationsService = TranslationsService.getInstance();
	let translationStrings = JSON.parse($("#support-article-toc-translations").html());
	translationsService.init(translationStrings);

	let initTableOfContents = function () {
		let $toc = $('.js-table-of-contents');
		let $articleTitle = $('.js-step-article-title');

		let sectionNames = [];

		function ensureUnique(sectionName: string): string {
			for (let nextName of sectionNames) {
				if (nextName === sectionName) {
					// If there's already a section by this name, add a "-" and the current Unix timestamp
					sectionName = sectionName + (new Date().getTime());
					break;
				}
			}

			return sectionName;
		}


		function strip(html)
		{
			let tmp = document.createElement("DIV");
			tmp.innerHTML = html;
			return tmp.textContent || tmp.innerText || "";
		}

		function constructItem(item: any) {
			let itemTemplate = `<li class="table-of-contents__item">
				<a href="#" class="table-of-contents__trigger js-toc-trigger" data-target="${item.sectionName}">${item.title}</a>
			</li>`;
			return $(itemTemplate);
		}

		$('[data-sf-element="Section Nav"]').each(function(index) {
			let $this = $(this);
			$this.addClass('v-support-article__section');
			$(`<div class="v-support-article__more-help">
					<a href="#contact-support" class="btn-xs btn btn-secondary js-smooth-scroll">
					${translationsService.translate('CatalogLabel.GetMoreHelp')}
					</a>
				</div>`).appendTo($this);
			let $content;
			let $strippedContent;
			let $navList = $('.js-table-of-contents');
			//if the section nav has a title in sitefinity do this
			if($this.data('placeholder-label') && $this.data('placeholder-label') != "Section Title") {
				$content = $this.data('placeholder-label');
				$strippedContent = strip($content);
			}
			// Or else grab the first heading and use that as the title
			else {
				if($this.find('h1, h2, h3').length) {
					$content = $(this).find('h1, h2, h3').eq(0).text();
					$strippedContent = strip($content);
				} else {
					$content = "Section is Untitled";
					$strippedContent = strip($content);
				}
			}


			let title = $strippedContent;
			let sectionName = ensureUnique(slugify($strippedContent));


			$this.data('placeholder-label', $content);
			$this.attr('data-section', sectionName);


			let item = {
				sectionName: sectionName,
				title: title
			};

			$navList.append(constructItem(item));


			$('body').on('click', '.js-toc-trigger', function(e) {
				var $this = $(this);
				var dataTarget = $(this).attr('data-target');
				var $target = $(`[data-section="${dataTarget}"]`);
				$('.js-toc-trigger').removeClass('state-active');

				$this.addClass('state-active');

				if ($target.length) {
					$('html, body').stop().animate({
						scrollTop: $target.offset().top
					}, 800);
				}

				e.preventDefault();
			});

		});
	};

	let setupLinks = function () {
		$('.js-contact-pfister').attr('href', $('.js-contact-us').attr('href'));
		$('.js-products-in-category').attr('href', $('nav.breadcrumbs').data('support-category'));
	};

	export function init() {
		// Initializing this module in Sitefinity editing mode leaves artifacts in the published page, so
		// if we detect the SF editing interface, bail
		if ($('.sfPageContainer').length) {
			return;
		}

		initTableOfContents();
		setupLinks();
	}
}

PFF.controllers.supportArticle.init();



// WEBPACK FOOTER //
// ./js/PFF/controllers/supportArticle.ts